import { render, staticRenderFns } from "./ProspectFilter.vue?vue&type=template&id=28081a3c"
import script from "./ProspectFilter.vue?vue&type=script&lang=ts"
export * from "./ProspectFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports